import React from 'react';
import { hasPackage } from '../../utils/entitlements';
import PropertyExplorerTab from './PropertyExplorerTab';
import './css/RealEstateWorkspace.css';

function RealEstateWorkspace() {
  if (!hasPackage('real_estate')) {
    return (
      <div className='re-workspace'>
        <header className='re-workspace__header'>
          <div>
            <h1 className='re-workspace__title'>Real Estate</h1>
            <p className='re-workspace__subtitle'>
              This workspace is available when the Real Estate package is enabled on the plan or subscription.
            </p>
          </div>
        </header>
      </div>
    );
  }

  return (
    <div className='re-workspace'>
      <header className='re-workspace__header'>
        <div>
          <h1 className='re-workspace__title'>Real Estate</h1>
          <p className='re-workspace__subtitle'>
            Portfolio overview and property workspace
          </p>
        </div>
      </header>

      <div className='re-workspace__content'>
        <PropertyExplorerTab />
      </div>
    </div>
  );
}

export default RealEstateWorkspace;
